import { Box, Button, Grid, Stack, TextField, Typography } from "@mui/material";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import React from "react";

const FooterReviewVp = () => {
  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xl={12} lg={12} sm={12} xs={12}>
          <Grid container>
            <Grid item xl={12} lg={12} sm={12} xs={12} textAlign="center">
              <Typography variant="h6">Lokasi/Bisnis Unit</Typography>
              <br />
            </Grid>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <div style={{ textAlign: "center" }}>
                  <Typography variant="body1">Dibuat oleh:</Typography>
                  <br />
                  <br />
                  <br />
                  <Typography variant="body1">
                    <b>Nama Lengkap</b>
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Date().toLocaleDateString().toString()}{" "}
                    {new Date().toLocaleTimeString().toString()}
                  </Typography>
                </div>
              </Stack>
            </Grid>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <div style={{ textAlign: "center" }}>
                  <Typography variant="body1">Dikeluarkan oleh:</Typography>
                  <br />
                  <br />
                  <br />
                  <Typography variant="body1">
                    <b>Nama Lengkap</b>
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Date().toLocaleDateString().toString()}{" "}
                    {new Date().toLocaleTimeString().toString()}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <br />
      <Grid container spacing={5}>
        <Grid item xl={12} lg={12} sm={12} xs={12}>
          <Grid container>
            <Grid item xl={12} lg={12} sm={12} xs={12} textAlign="center">
              <Typography variant="h6">Region</Typography>
              <br />
            </Grid>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <br />
                <div style={{ textAlign: "center" }}>
                  <Typography variant="body1">Diverifikasi oleh:</Typography>
                  <br />
                  <br />
                  <br />
                  <Typography variant="body1">
                    <b>Nama Lengkap</b>
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Date().toLocaleDateString().toString()}{" "}
                    {new Date().toLocaleTimeString().toString()}
                  </Typography>
                </div>
              </Stack>
            </Grid>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <br />
                <div style={{ textAlign: "center" }}>
                  <Typography variant="body1">Disetujui oleh:</Typography>
                  <br />
                  <br />
                  <br />
                  <Typography variant="body1">
                    <b>Nama Lengkap</b>
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Date().toLocaleDateString().toString()}{" "}
                    {new Date().toLocaleTimeString().toString()}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <br />
      <Box
        sx={{
          p: 3,
          borderRadius: 3,
          display: "block",
          backgroundColor: "#fff",
        }}
      >
        <TextField
          name="text1"
          label="Catatan"
          variant="outlined"
          type="text"
          fullWidth
          multiline
          minRows={3}
          // value={input}
          // onChange={(e) => setInput(e.target.value)}
        />
      </Box>
      <br />
      <br />
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "10vh" }}
      >
        <Grid item xs={3}>
          <Stack spacing={2} direction="row">
            <Button variant="outlined" sx={{ width: "150px" }}>
              Save As Draft
            </Button>
            <Button
              variant="contained"
              sx={{ width: "150px" }}
              type="submit"
              onClick={() => {}}
            >
              ISSUE
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <a href="/hsse/incident/reviewlokasi" style={{ textDecoration: "none" }}>
        <Button
          variant="text"
          startIcon={<FastRewindIcon />}
          sx={{ color: "black" }}
        >
          Back
        </Button>
      </a>
    </div>
  );
};

export default FooterReviewVp;
